// covered-by: frontends/carrie/src/ask-v2/pages/__tests__/AskV2ProjectPage.test.tsx
// covered-by: frontends/carrie/src/ask-v2/project/__tests__/openItemKindLabel.test.ts
import { type AskPunttOpenItemKind } from "@mg/schemas/src/christo/askPunttOpenItems";
import { type TFunction } from "i18next";

export function openItemKindLabel(
  kind: AskPunttOpenItemKind,
  t: TFunction<"ui">,
): string {
  switch (kind) {
    case "unjudged_finding":
      return t("askV2.openItems.kind.finding");
    case "source_conflict":
      return t("askV2.openItems.kind.sourceConflict");
    case "missing_input":
      return t("askV2.openItems.kind.missingInput");
    case "vague_requirement":
      return t("askV2.openItems.kind.vagueRequirement");
    case "expert_question":
      return t("askV2.openItems.kind.expertQuestion");
    case "project_blocker":
      return t("askV2.openItems.kind.projectBlocker");
    default:
      return kind;
  }
}
